import { ConfigState } from './store/config';

const default_config: ConfigState = {
  loaded: false,
  baseUrl: 'https://api.mobilix.dev.allbin.se',
  attachmentUrl: 'https://storage.googleapis.com/mobilix-dev',
  allauth: {
    apiBaseUrl: 'https://api.auth.dev.allbin.se',
    kratosUrl: 'https://identity.allbin.se',
    audience: 'https://api.mobilix.dev.allbin.se',
    applicationUri: 'https://local.allbin.se:3000',
    userManagementUrl: 'https://allauth.dev.allbin.se',
  },
  noHookApiCalls: false,
  policeReportUrl: 'https://etjanster.polisen.se/eanmalan/skadegorelse/',
  locale: 'sv-SE',
  mapDefaultCenter: {
    lat: 59.7696304,
    lng: 17.53084788,
  },
};

export default default_config;
